// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { OnlineCourseCard } from '../../types/Model';

export interface OnlineCourseRelatedRequestPayload {
  id: string;
  loadingType: LoadingType;
}
export interface OnlineCourseRelatedSuccessPayload {
  onlineCourseRelatedData: OnlineCourseCard[];
  id: string;
  loadingType: LoadingType;
}

export interface OnlineCourseRelatedFailPayload {
  error: Error;
}

export const getOnlineCourseRelatedActions = createAsyncAction(
  'elearning/GET_ONLINE_COURSE_RELATED',
  'elearning/GET_ONLINE_COURSE_RELATED_SUCCESS',
  'elearning/GET_ONLINE_COURSE_RELATED_FAIL'
)<
  OnlineCourseRelatedRequestPayload,
  OnlineCourseRelatedSuccessPayload,
  OnlineCourseRelatedFailPayload
>();
